export default __webpack_public_path__ + "static/media/Ground Coffee.b0beeb99.png";